import React, { useEffect , useMemo } from "react";
import {useSocketIo} from '../../context/SocketContext'

import { useCallogs } from "../../apis";

import subMinutes from 'date-fns/subMinutes'
import isBefore from 'date-fns/isBefore'
import isAfter from 'date-fns/isAfter'

import PageTitle from "../../components/PageTitle/PageTitle";

import {
    Grid
} from "@material-ui/core";
import CallLogTable from './Table'
import HouseholdCases from '../householdCases/HouseholdCases'
//Requirements 12.1 - 12.6. This page IS the dashboard (Layout.js renders it for
///app/dashboard with isDashboard); the section renders itself only for a user
//holding the Appointment Handler role.
import DashboardAppointments from '../appointments/DashboardAppointments'
import Button from '@material-ui/core/Button'


const CallLogs = ({history,isDashboard}) => {
   
    const { callLogs, isLoading, isError,mutate } = useCallogs(isDashboard)  
    const rows = useMemo(() => Array.isArray(callLogs) ? callLogs.filter(row => row && typeof row === 'object' && !Array.isArray(row)) : [], [callLogs])
    const listError = isError || (callLogs !== undefined && !Array.isArray(callLogs) ? new Error('Invalid call-log data') : null)
    const socketIo = useSocketIo();
    
    useEffect(() => {
        if (!socketIo) return
        // Fetch the complete list for the current SWR key. A socket message is
        // only one row and must not become the initial data for the history page.
        const refresh = () => mutate()
        socketIo.on('message', refresh)
        return () => socketIo.off('message', refresh)
    },[socketIo,mutate])
    
    const completedCallLogs = useMemo(() => {       
       const dateCutOffCallMustHaveEnded = subMinutes(new Date(), 30)
       const sortedCompetedCalls = rows
       .filter(callLog => (!!callLog.finishedAt || isBefore(new Date(callLog.startedAt), dateCutOffCallMustHaveEnded)) && !callLog.hideCall)
       .sort((a,b) => b.id - a.id)
       return sortedCompetedCalls.slice(0,25)
    }, [rows] )

    const activeCallLogs = useMemo(() => {
       const dateCutOffCallMustHaveEnded = subMinutes(new Date(), 30)
       return rows
       .filter(callLog => (!callLog.finishedAt && isAfter(new Date(callLog.startedAt), dateCutOffCallMustHaveEnded)) && !callLog.hideCall)
       .sort((a,b) => b.id - a.id) 
    }, [rows] )

    return (
        <>
          {!!listError && <div role="alert">The call logs could not be refreshed. <Button onClick={() => mutate()}>Retry</Button></div>}
          <Grid container spacing={2}> 
            {!!isDashboard && 
                <>
                    <Grid item xs={12}>
                        <CallLogTable loading={isLoading && !listError} error={!rows.length ? listError : null} title="Active Calls" callLogs={activeCallLogs} history={history} /*loadCallerCallLogs={loadCallerCallLogs}*/ />
                    </Grid>
                    <Grid item xs={12}>
                        <CallLogTable loading={isLoading && !listError} error={!rows.length ? listError : null}  title="Recent Calls" callLogs={completedCallLogs} history={history}  /*loadCallerCallLogs={loadCallerCallLogs}*/ />
                    </Grid>
                    <Grid item xs={12}>
                        <HouseholdCases history={history} userOpenCasesView={true} />
                    </Grid>
                    <Grid item xs={12}>
                        <DashboardAppointments />
                    </Grid>
                </> 
            }
            {!isDashboard && 
                <>
                    <Grid item xs={12}>
                        <CallLogTable title="Call Logs History" loading={isLoading && !listError} error={!rows.length ? listError : null} callLogs={rows} history={history}  />
                    </Grid>
                </>
            }
          </Grid>
        </>
      );
}

export default CallLogs
